<template>
  <div v-if="item.items.length > 0">
    <h4
      @click.prevent="handleClick"
      class="panel-mobile-menu-row"
      :class="{
        'panel-mobile-menu-row--interactive cursor-pointer dark:hover:bg-gray-800/80':
          displayAsButton,
        'panel-mobile-menu-row--active font-bold text-primary-500 dark:text-primary-400': item.active,
        'text-zinc-600 dark:text-zinc-400': collapsed && !item.active,
      }"
    >
      <span class="panel-mobile-menu-row__icon">
        <NavIcon :name="item.icon" width="20" height="20" />
      </span>

      <span class="panel-mobile-menu-row__label">
        {{ item.name }}
      </span>

      <span
        v-if="item.collapsable"
        class="panel-mobile-menu-row__chevron"
      >
        <CollapseButton :collapsed="collapsed" :to="item.path" />
      </span>
    </h4>

    <div
      v-if="!collapsed"
      class="panel-mobile-menu__submenu"
      data-submenu-open="true"
    >
      <component
        :key="child.name"
        v-for="child in item.items"
        :is="child.component"
        :item="child"
      />
    </div>
  </div>
</template>

<script>
import { Collapsable } from '@/mixins'
import NavIcon from './NavIcon.vue'

export default {
  components: {
    NavIcon,
  },

  mixins: [Collapsable],

  props: ['item'],

  methods: {
    handleClick() {
      if (this.item.collapsable) {
        this.toggleCollapse()
      }
    },
  },

  computed: {
    component() {
      if (this.item.items.length > 0) {
        return 'div'
      }

      return 'h3'
    },

    displayAsButton() {
      return this.item.items.length > 0 && this.item.collapsable
    },

    collapsedByDefault() {
      return this.item?.collapsedByDefault ?? false
    },
  },
}
</script>
